import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { colorsPalette, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    imageWrapper: {
      width: 78,
      height: 78,
      position: 'relative',
      marginBottom: SMALL_MARGIN,
      [theme.breakpoints.up('md')]: {
        width: 116,
        height: 116,
      },
      '& svg': {
        position: 'absolute',
        left: '50%',
        top: '50%',
        width: '60%',
        height: '60%',
        transform: 'translate(-50%, -50%)',
        color: colorsPalette.white,
      },
    },
    circle: {
      width: '100%',
      height: '100%',
    },
  });
});

export default useStyles;
